import _add from "./add";
import _ceil from "./ceil";
import _divide from "./divide";
import _floor from "./floor";
import _max from "./max";
import _maxBy from "./maxBy";
import _mean from "./mean";
import _meanBy from "./meanBy";
import _min from "./min";
import _minBy from "./minBy";
import _multiply from "./multiply";
import _round from "./round";
import _subtract from "./subtract";
import _sum from "./sum";
import _sumBy from "./sumBy";
var exports = {};
exports = {
  "add": _add,
  "ceil": _ceil,
  "divide": _divide,
  "floor": _floor,
  "max": _max,
  "maxBy": _maxBy,
  "mean": _mean,
  "meanBy": _meanBy,
  "min": _min,
  "minBy": _minBy,
  "multiply": _multiply,
  "round": _round,
  "subtract": _subtract,
  "sum": _sum,
  "sumBy": _sumBy
};
export default exports;
export const add = exports.add;